import { ParseObservable } from './parse-observable';
import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { User } from './../data';
import { UserQuery } from './../queries';

declare var FB;

@Injectable()
export class UserService {
  public user: Observable<User>;
  private userSubject: BehaviorSubject<User>;

  constructor() {
    this.userSubject = new BehaviorSubject(User.current());
    this.user = this.userSubject.asObservable();
  }

  public save(user: User): Observable<User> {
    return user.rx().save()
        .publishReplay(1)
        .refCount()
        .do((user) => this.userSubject.next(user));
  }

  public login(username: string, password: string): Observable<Parse.User> {
    return new ParseObservable(Parse.User.logIn(username, password))
        .publishReplay(1)
        .refCount()
        .do(() => this.userSubject.next(User.current()));
  }

  public signup(username: string, password: string, att: any): Observable<Parse.User> {
    return new ParseObservable(Parse.User.signUp(username, password, att))
        .publishReplay(1)
        .refCount()
        .do((user) => this.userSubject.next(User.current()));
  }

  public resetPassword(email: string): Observable<Parse.User> {
    return new ParseObservable(Parse.User.requestPasswordReset(email)).publishReplay(1).refCount();
  }

  public fbLogin(): Observable<Parse.User> {
    return this.fbLoginObservable().flatMap(user => {
      if (!user.existed()) {
        return this.fbMe(user).do((user) => this.userSubject.next(user as User));
      }
      return Observable.of(user).do((user) => this.userSubject.next(user as User));
    });
  }

  public logout(): Observable<any> {
    return new ParseObservable(Parse.User.logOut())
      .publishReplay(1)
      .refCount()
      .do((user) => this.userSubject.next(null));
  }

  private fbLoginObservable(): Observable<Parse.User> {
    let observable = new Observable<Parse.User>((observer: Observer<any>) => {
      Parse.FacebookUtils.logIn('email', {
        success: (user: Parse.User) => {
          observer.next(user);
          observer.complete();
        },
        error: (user, error) => {
          observer.error(error);
        }
      });
    });
    return observable;
  }

  private fbMe(user: Parse.User): Observable<Parse.User> {
    return new Observable((observer: Observer<any>) => {
      FB.api('/me?fields=first_name,last_name,email', (me) => {
        user.save({firstName: me['first_name'], lastName: me['last_name'], email: me['email']}).then(
          (user) => {
            observer.next(user);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
      });
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/user-service.ts